<template>
    <div class="dlParam comWDSParams_viewDP">
        <div class="com_param_div">
            <div class="params_div">
                <span>数据堆叠</span>
                <el-input v-model="config.stack" @change="getRender" placeholder="请输入数据堆叠类型"></el-input>
            </div>
        </div>
        <div class="com_param_div">
            <div class="params_div checkViewConfig">
                <el-checkbox v-model="config.customColor" @change="getColor">自定义颜色</el-checkbox>
            </div>
            <div class="params_div" v-if="config.customColor">
                <span>颜色</span>
                <el-color-picker v-model="config.color" show-alpha @change="getRender"></el-color-picker>
            </div>
        </div>
        <div class="com_param_div">
            <div class="params_div checkViewConfig">
                <el-checkbox v-model="config.label.show" @change="getRender">是否展示数值</el-checkbox>
            </div>
        </div>
        <div class="com_param_div">
            <div class="params_div checkViewConfig">
                <span>面积颜色</span>
                <el-color-picker v-model="config.areaStyle.color" show-alpha @change="getRender"></el-color-picker>
            </div>
        </div>
        <div class="com_param_div">
            <div class="params_div checkViewConfig">
                <span>阴影大小</span>
                <el-input v-model="config.areaStyle.shadowBlur" @change="getRender" placeholder="请输入数据堆叠类型"></el-input>
            </div>
        </div>
        <div class="com_param_div">
            <div class="params_div checkViewConfig">
                <span>阴影颜色</span>
                <el-color-picker v-model="config.areaStyle.shadowColor" show-alpha @change="getRender"></el-color-picker>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 10:48 上午
     */
    export default {
        name: 'dlParam',
        components: {},
        props: {
            index: {
                type: Number,
                default: 0
            },
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.dlList[this.index].params || {};
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.dlList[this.index].params || {};
                }
            },
            nowChart() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart;
                }
            }
        },
        data() {
            return {
                lTAxisList: [
                    {value: 0, label: '主轴'},
                    {value: 1, label: '次轴'}
                ]
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
            //颜色
            getColor() {
                if (!this.config.customColor) {
                    this.getRender();
                    this.config.color = '';
                }
            }
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .dlParam {

    }
</style>
